<template>
    <div class="submit-button">
        <btn :theme="theme"
             :size="size"
             v-disabled="!$form.$isDirty || $form.$isSaving"
             @click="$form.$submit"
             v-html="label || __('form/save')"
        />
        <span v-if="$form.$isSaving" class="status ml-2">
            {{ saving || __('form/submit_saving') }} <span class="loading-dots"/>
        </span>
        <span v-else-if="$form.$isSaved" class="status ml-2">
            <icon name="check-circle"/> {{ success || __('form/submit_success') }}
        </span>
    </div>
</template>

<script>
    export default {
        props: {
            label: {type: String, default: null},
            saving: {type: String, default: null},
            success: {type: String, default: null},
            theme: {type: String, default: 'primary'},
            size: {type: String, default: 'lg'},
        },

        data() {
            return {
                component: null,
            };
        },

        computed: {
            $form() {
                return this.component.$form;
            },
        },

        beforeMount() {
            let component = this;

            while (component.$parent) {
                component = component.$parent;
                if (component.hasOwnProperty('$form')) {
                    this.component = component;
                    break;
                }
            }

            if (!this.component) {
                throw 'submit-button need to be used inside form component';
            }
        },
    };
</script>